'use client'

import ProductPage from '../../product/[originalPath]/[edgeFlags]/[productPageId]/[CsrFlag]/[...sku]'

import { useEffect, useState } from 'react'

import { useUserStore } from 'Clutch/Stores/UserStore/UserStore'
import { useRouter } from 'next/router'

import GraphQLRequest from 'Clutch/Utilities/GraphQLClient/GraphQLClient'

export async function getServerSideProps() {
  return { props: {} }
}

export default function PreviewPage() {
  const router = useRouter()
  const { skuBase, skuVariant } = router.query
  const webUserGuid = useUserStore((x) => x.context.userGuid)

  const [productData, setProductData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!router.isReady || !skuBase || !webUserGuid) return

    async function fetchPreview() {
      try {
        const variant = Array.isArray(skuVariant) ? skuVariant[0] : skuVariant
        const variables = {
          skuVariantOrSkuBaseNumber: variant || skuBase,
          skuVariant: variant || undefined,
          isPreview: true,
          selectedIndexOptions: [],
          webUserGuid,
        }

        const res = await GraphQLRequest('/graphql/products', '3563811612bb1ab51c32ec153aae5e1a', variables)

        if (!res?.productPage || res.productPage.should404) {
          router.replace('/404')
          return
        }

        res.productPage.isPreview = true
        res.productPage.csrFlag = '0'
        setProductData(res.productPage)
        setLoading(false)
      } catch (e) {
        console.error('Preview fetch error:', e)
        setLoading(false)
      }
    }

    fetchPreview()
  }, [router.isReady, skuBase, skuVariant, webUserGuid])

  if (loading || !productData) return null

  return <ProductPage {...productData} />
}
